import { styled } from 'styled-components'
import theme from '../../../../Theme'
import Box from '@mui/material/Box'

export const StyledIntroductionScreen = styled(Box)`
  height: 100%;
  width: 100%;
  align-content: center;
`

export const StyledInitialScreen = styled(Box)`
  display: flex; 
  justify-content: space-between; 
  flex-direction: column;
  margin: ${theme.spacing(4)} ${theme.spacing(6)};
`
export const StyledBackgroundImage = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`

export const StyledIntroductionMessage = styled(Box)`
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: #000;
  margin-bottom: 8px;
`

export const StyledIntroductionSubMessage = styled(Box)`
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
  color: #000;
  margin-bottom: 24px;
`
